"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = _default;
exports.TEXTFIELD_ID = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper.js"));

var _Question = require("./Question2");

var _KeyboardHelper = require("../../../helpers/KeyboardHelper");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _AnswersBox = _interopRequireDefault(require("./AnswersBox.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Button = _interopRequireDefault(require("./../Button"));

var _Question2 = _interopRequireDefault(require("./Question2.scss"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _AnswerBoxStrings = require("./AnswerBoxStrings");

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper.js"));

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _AnswerBoxStyle = require("./styles/AnswerBoxStyle");

var _ThemeStore = require("../ThemeStore/ThemeStore2");

var _core = require("@material-ui/core");

var _Feedback = _interopRequireDefault(require("@material-ui/icons/Feedback"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var MAX_FONT_SIZE = 16;
var MIN_FONT_SIZE = 6;
var TEXTFIELD_ID = 'textfieldInput_';
exports.TEXTFIELD_ID = TEXTFIELD_ID;

function _default(props) {
  var _useState = (0, _react.useState)(MAX_FONT_SIZE),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      temporaryFontSize = _useState2[0],
      setTemporaryFontSize = _useState2[1];

  var _useState3 = (0, _react.useState)(false
  /*true*/
  ),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      useTemporaryFontSize = _useState4[0],
      setUseTemporaryFontSize = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      buttonDisabled = _useState6[0],
      setButtonDisabled = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      selectedAnswers = _useState8[0],
      setSelectedAnswers = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      seAnswered = _useState10[0],
      setSeAnswered = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      seIndex = _useState12[0],
      setSeIndex = _useState12[1];

  var _useState13 = (0, _react.useState)(0),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      questionID = _useState14[0],
      setQuestionID = _useState14[1];

  var startFontSize = (0, _react.useRef)(MAX_FONT_SIZE);
  var calculationDelay = (0, _react.useRef)();
  var interval = (0, _react.useRef)(); // @ts-ignore

  var foundFontSizes = (0, _react.useRef)((0, _ArrayHelper.prefilledArray)(props.question.answers.length, null));
  var perfectFontSize = (0, _react.useRef)();

  var _useState15 = (0, _react.useState)({
    answer: '',
    isCorrect: false,
    number: 0
  }),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      freeTextUserAnswer = _useState16[0],
      setFreeTextUserAnswer = _useState16[1];

  (0, _react.useEffect)(function () {
    if (props.question.id != questionID) {
      setQuestionID(props.question.id);
      console.log('PFSC: ', questionID);
    }

    calculateAllFontSizesWithDelay();

    for (var i = 0; i < 4; i++) {
      var box = document.getElementById(getIdForSingleAnswerContainer(i));

      if (box) {
        var answerImg = props.question.answers[i].answer.includes('<img');

        if (!answerImg) {
          calculateFontSize(i);
        } else {
          console.log("Antwort ".concat(i, " hat ein Bild"));
          setPerfectSizeFontForAnswer(i);
        }
      }
    }

    _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(calculateAllFontSizesWithDelay);

    return function cleanup() {
      _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(calculateAllFontSizesWithDelay);

      clearTimeout(calculationDelay.current);
    };
  });
  (0, _react.useEffect)(function () {
    setUseTemporaryFontSize(true);
  }, [questionID]);
  (0, _react.useEffect)(function () {
    startFontSize.current = 0;

    if (temporaryFontSize > MIN_FONT_SIZE) {
      calculateAllFontSizes();
    }
  }, [temporaryFontSize, useTemporaryFontSize]);
  (0, _react.useEffect)(function () {
    if (!props.showScrollIndicator) {
      setButtonDisabled(true);
      setTimeout(function () {
        return setButtonDisabled(false);
      }, 500);
    }
  }, [props.showScrollIndicator]);
  (0, _react.useEffect)(function () {
    if (props.isTimeOver === true) {
      console.log('onTimeOver effect');
      setSelectedAnswers([]);
    }
  }, [props.isTimeOver]);
  (0, _react.useEffect)(function () {
    if (!props.questionAnswered) {
      setSelectedAnswers([]);
    }
  }, [props.questionAnswered]);
  (0, _react.useEffect)(function () {
    if (interval.current && !props.showScrollIndicator) {
      clearIntervalHandleAnswerBox();
    }
  }, [props.showScrollIndicator]);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (props.sendMC) {
        sendMCAnswers();
      }

      props.unsetMCAlert();
    }, 200);
  }, [props.sendMC]);
  var dynamicStyles = (0, _AnswerBoxStyle.getAnswerBoxStyles)({
    quiz: quizTheme,
    currentTheme: currentTheme
  });
  var muiStyles = (0, _core.makeStyles)(function (theme) {
    return {
      root: dynamicStyles.inputStyle
    };
  });
  var muiClasses = muiStyles();

  var _useThemeStore = (0, _ThemeStore.useThemeStore)('quiz'),
      _useThemeStore2 = (0, _slicedToArray2["default"])(_useThemeStore, 1),
      quizTheme = _useThemeStore2[0];

  var _useThemeStore3 = (0, _ThemeStore.useThemeStore)('currentTheme'),
      _useThemeStore4 = (0, _slicedToArray2["default"])(_useThemeStore3, 1),
      currentTheme = _useThemeStore4[0];

  if (props.selectedAnswers && props.selectedAnswers[0].text) {
    freeTextUserAnswer.answer = props.selectedAnswers[0].text;
  }

  function setPerfectSizeFontForAnswer(answerNumber) {
    foundFontSizes.current[answerNumber] = true;

    var _perfectFontSize = Math.max(MIN_FONT_SIZE, temporaryFontSize);

    if (perfectFontSize.current !== _perfectFontSize && foundFontSizes.current.every(function (b) {
      return b;
    })) {
      perfectFontSize.current = _perfectFontSize;
      props.onPerfectFontSizeFound(perfectFontSize.current);
      setUseTemporaryFontSize(false);
    }
  }

  function calculateAllFontSizesWithDelay() {
    clearTimeout(calculationDelay.current); // @ts-ignore

    calculationDelay.current = setTimeout(function () {
      startFontSize.current = MAX_FONT_SIZE;
      foundFontSizes.current = (0, _ArrayHelper.prefilledArray)(props.question.answers.length, null);
      calculateAllFontSizes();
    }, 100);
  }

  function calculateAllFontSizes() {
    for (var i = 0; i < props.question.answers.length; i++) {
      var box = document.getElementById(getIdForSingleAnswerContainer(i));

      if (box) {
        var answerImg = props.question.answers[i].answer.includes('<img');

        if (!answerImg) {
          calculateFontSize(i);
        } else {
          console.log("Antwort ".concat(i, " hat ein Bild"));
          setPerfectSizeFontForAnswer(i);
        }
      }
    }
  } //TODO: font size needs better implementation, this one is broken


  function calculateFontSize(answerNumber) {
    if (!useTemporaryFontSize) {
      return;
    }

    var textBox = document.getElementById(getIdForAnswerSpan(answerNumber));
    var outerBox = document.getElementById(getIdForAnswerLabel(answerNumber));

    if (!outerBox || !textBox) {
      console.error('AnswerBox: getElementById');
      return;
    }

    var innerTables = textBox.getElementsByTagName('table');
    var widestInnerTable = innerTables && innerTables.length > 0 ? (0, _from["default"])(innerTables).sort(function (t1, t2) {
      return t1.offsetWidth > t2.offsetWidth ? -1 : 1;
    })[0] : null;
    var outerHeight = outerBox.offsetHeight - 12; // border width

    var outerWidth = outerBox.offsetWidth - 12; // border width

    var innerHeight = textBox.offsetHeight;
    var innerWidth = textBox.offsetWidth;
    var innerTableWidth = widestInnerTable ? widestInnerTable.offsetWidth : 0;

    if (props.question.type === _Question.QUESTION_TYPES.SC || props.question.type === _Question.QUESTION_TYPES.MC) {
      // if we have a sc or mc question, remove 42 px of the outer width for the radio button/ checkbox
      if (startFontSize.current || outerWidth - 42 < innerWidth || innerWidth < innerTableWidth) {
        // make font smaller
        var newSize = (startFontSize.current || temporaryFontSize) - 0.5;

        if (newSize > MIN_FONT_SIZE) {
          setTemporaryFontSize(newSize);
        } else {
          setPerfectSizeFontForAnswer(answerNumber);
        }
      } else {
        // this.checkFontSize(answerNumber)
        setPerfectSizeFontForAnswer(answerNumber);
      }
    } else {
      if (startFontSize.current || outerHeight < innerHeight || outerWidth < innerWidth || innerWidth < innerTableWidth) {
        // make font smaller
        var _newSize = (startFontSize.current || temporaryFontSize) - 0.5;

        if (_newSize > MIN_FONT_SIZE) {
          setTemporaryFontSize(_newSize);
        } else {
          setPerfectSizeFontForAnswer(answerNumber);
        }
      } else {
        // this.checkFontSize(answerNumber)
        setPerfectSizeFontForAnswer(answerNumber);
      }
    }
  }

  function showSpecificFeedback(event, feedback) {
    if (event) event.stopPropagation();
    props.showSpecificFeedback(feedback);
  }

  function getIdForAnswerLabel(answerNumber) {
    return "answers_".concat(props.question.number, "_").concat(answerNumber);
  }

  function getIdForAnswerSpan(answerNumber) {
    return "answers_span_".concat(props.question.number, "_").concat(answerNumber);
  }

  function getIdForSingleAnswerContainer(answerNumber) {
    return "singleAnswersContainer_".concat(props.question.number, "_").concat(answerNumber);
  }

  function getFontSize() {
    return '2vh';
    /*useTemporaryFontSize
    ? temporaryFontSize || props.fontSize
    : props.fontSize || temporaryFontSize
    */
  }

  function selectAnswer(answer) {
    if (props.disabled || props.questionAnswered) {
      return;
    }

    if (props.question.type === _Question.QUESTION_TYPES.MC || props.question.type === _Question.QUESTION_TYPES.SC) {
      var arr = (0, _toConsumableArray2["default"])(selectedAnswers);
      var index = arr.indexOf(answer);

      if (index === -1) {
        if (props.question.type === 'SC' && selectedAnswers.length === 1) {
          arr.pop();
          arr.push(answer);
        } else {
          arr.push(answer);
        }
      } else if (index !== -1) {
        arr.splice(index, 1);
      }

      setSelectedAnswers(arr);

      if (_config["default"].doNotShowSendButtonForMCSC) {
        if (props.question.type === _Question.QUESTION_TYPES.SC) {
          submitAnswers(arr);
        } else if (props.question.type === _Question.QUESTION_TYPES.MC) {
          var correctAnswers = 0;
          props.question.answers.forEach(function (answer) {
            if (answer.isCorrect) {
              correctAnswers++;
            }
          });

          if (correctAnswers === arr.length) {
            submitAnswers(arr);
          }
        }
      }
    } else {
      props.onSelectAnswer(answer);
    }
  }

  function sendMCAnswers(userAnswers) {
    var answers = userAnswers && userAnswers.length > 0 ? userAnswers : selectedAnswers;
    props.onSelectAnswer(answers);
  }

  function onFreeTextAnswerChange(evt) {
    var inputVAL = evt.target.value;
    setFreeTextUserAnswer(_objectSpread(_objectSpread({}, freeTextUserAnswer), {}, {
      answer: inputVAL
    }));
  }

  function showSeFeedback() {
    props.onSelfEvaluation(freeTextUserAnswer);
    setSeAnswered(true);
    setSeIndex(1);
  }

  function submitAnswers(userAnswers) {
    var type = props.question.type;
    var answers = userAnswers && userAnswers.length > 0 ? userAnswers : selectedAnswers;

    if (type === _Question.QUESTION_TYPES.MC && answers.length === 1) {
      // showAlert -> MC Question! ja -> props.onSelectAnswers, nein -> raus
      props.setMCAlert();
      return;
    }

    if (type === _Question.QUESTION_TYPES.VALNUM || type === _Question.QUESTION_TYPES.VALSTR || type === _Question.QUESTION_TYPES.SE) {
      if (freeTextUserAnswer.answer.length === 0) {
        return;
      }

      props.onSelectAnswer(freeTextUserAnswer);
      (0, _KeyboardHelper.hideKeyboard)(true);
    } else {
      props.onSelectAnswer(answers);
    }
  }

  function setIntervalHandleAnswerBox() {
    console.log('SCROLLINDICATOR CLICK'); // @ts-ignore

    interval.current = setInterval(props.onTouchAnswers, 5);
  }

  function clearIntervalHandleAnswerBox() {
    // @ts-ignore
    clearInterval(interval.current);
  }

  function testForAndGetSpecificFeedback(answer) {
    var showSpecificFeedbackIcon = false;
    var specificFeedback = '';

    if (props.question.type === _Question.QUESTION_TYPES.MC && props.questionAnswered) {
      /**
       * not correct and selected
       */
      if (!answer.isCorrect && selectedAnswers.findIndex(function (ans) {
        return ans.number === answer.number;
      }) > -1) {
        if (props.question.detailedFeedback[answer.number] && props.question.detailedFeedback[answer.number].wrong) {
          // @ts-ignore
          specificFeedback = props.question.detailedFeedback[answer.number].wrong.html || '';
          showSpecificFeedbackIcon = true;
        } // Do not show globalFeedback as detailedFeedback even if there is none
        // else if (props.question.feedback) {
        //   specificFeedback = props.question.feedback
        //   showSpecificFeedbackIcon = true
        // }

      }
      /**
       * correct and not selected
       */
      else if (answer.isCorrect && selectedAnswers.findIndex(function (ans) {
          return ans.number === answer.number;
        }) === -1) {
          if (props.question.detailedFeedback[answer.number] && props.question.detailedFeedback[answer.number].wrong) {
            // @ts-ignore
            specificFeedback = props.question.detailedFeedback[answer.number].wrong.html || '';
            showSpecificFeedbackIcon = true;
          } // Do not show globalFeedback as detailedFeedback even if there is none
          // else if (props.question.feedback) {
          //   specificFeedback = props.question.feedback
          //   showSpecificFeedbackIcon = true
          // }

        }
        /**
         * correct and selected
         */
        else if (answer.isCorrect && selectedAnswers.findIndex(function (ans) {
            return ans.number === answer.number;
          }) > -1 && props.question.detailedFeedback && props.question.detailedFeedback[answer.number] && props.question.detailedFeedback[answer.number].correct) {
            showSpecificFeedbackIcon = true; // @ts-ignore

            specificFeedback = props.question.detailedFeedback[answer.number].correct.html || '';
          }
          /**
           * not correct and not selected
           */
          else if (!answer.isCorrect && selectedAnswers.findIndex(function (ans) {
              return ans.number === answer.number;
            }) === -1 && props.question.detailedFeedback && props.question.detailedFeedback[answer.number] && props.question.detailedFeedback[answer.number].correct) {
              showSpecificFeedbackIcon = true; // @ts-ignore

              specificFeedback = props.question.detailedFeedback[answer.number].correct.html || '';
            }
    } // console.log('specific feedback', answer, showSpecificFeedbackIcon, specificFeedback)


    return {
      showSpecificFeedbackIcon: showSpecificFeedbackIcon,
      specificFeedback: specificFeedback
    };
  }

  if (props.reviewMode) {
    console.log('answer box in review mode', props);
  }

  if (props.question.type === _Question.QUESTION_TYPES.SE) {
    console.log('got an se question');

    var _buttonDisabled = freeTextUserAnswer.answer.length === 0;

    var textInput = /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100%'
      }
    }, props.disableAnswers ? null : /*#__PURE__*/_react["default"].createElement("form", {
      noValidate: true
    }, /*#__PURE__*/_react["default"].createElement(_TextField["default"] // label="AnswerField"
    , {
      id: "".concat(TEXTFIELD_ID).concat(props.question.number),
      type: 'text',
      value: freeTextUserAnswer.answer,
      onChange: onFreeTextAnswerChange,
      margin: "normal",
      autoComplete: 'off',
      className: _AnswersBox["default"].seAnswer,
      fullWidth: true,
      disabled: props.disableAnswers || props.reviewMode || props.questionAnswered,
      multiline: true,
      rowsMax: "10",
      onBlur: function onBlur() {
        setTimeout(function () {
          (0, _KeyboardHelper.hideKeyboard)(true);

          if (_DeviceInfoHelper["default"].isiOS()) {
            window.scrollTo(0, 0);
          } else if (_DeviceInfoHelper["default"].isAndroid()) {
            var frameId = "questionBoxFrame_".concat(props.question.number);
            var el = document.getElementById(frameId);

            if (el) {
              el.scrollTop = 0;
            }
          }
        }, 0);
      },
      onFocus: function onFocus(evt) {
        props.setTextfieldFocused();

        if (_DeviceInfoHelper["default"].isAndroid()) {
          evt.target.scrollIntoView();
        }
      }
    }), props.disableAnswers || props.reviewMode ? null : !props.textfieldFocusedBefore && /*#__PURE__*/_react["default"].createElement("div", {
      className: _AnswersBox["default"].cursor
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      variant: 'contained',
      color: 'default',
      onClick: showSeFeedback,
      className: "".concat(_Question2["default"].sendButton, " ").concat(props.questionAnswered ? _Question2["default"].displayNone : ''),
      disabled: props.disableAnswers ? false : _buttonDisabled
    }, props.disableAnswers ? /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: 10
      }
    }, 'Zur nächsten Frage') : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "send"), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: 10
      }
    }, (0, _AnswerBoxStrings.getString)('SEND_ANSWER'))))));

    return textInput;
  } else if (props.question.type === _Question.QUESTION_TYPES.VALSTR || props.question.type === _Question.QUESTION_TYPES.VALNUM) {
    var _buttonDisabled2 = freeTextUserAnswer.answer.length === 0; // @ts-ignore


    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100%'
      }
    }, props.disableAnswers ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_TextField["default"] // label="AnswerField"
    , {
      id: "".concat(TEXTFIELD_ID).concat(props.question.number),
      type: props.question.type === _Question.QUESTION_TYPES.VALSTR ? 'text' : 'number' // className={classes.textField}
      ,
      value: props.reviewMode ? freeTextUserAnswer.answer : null,
      onChange: onFreeTextAnswerChange,
      margin: "normal",
      className: _AnswersBox["default"].freetextAnswer,
      fullWidth: true,
      disabled: props.disableAnswers || props.reviewMode || props.questionAnswered,
      onBlur: function onBlur() {
        setTimeout(function () {
          (0, _KeyboardHelper.hideKeyboard)(true);

          if (_DeviceInfoHelper["default"].isiOS()) {
            window.scrollTo(0, 0);
          } else if (_DeviceInfoHelper["default"].isAndroid()) {
            var frameId = "questionBoxFrame_".concat(props.question.number);
            var el = document.getElementById(frameId);

            if (el) {
              el.scrollTop = 0;
            }
          }
        }, 0);
      },
      onFocus: function onFocus(evt) {
        props.setTextfieldFocused();

        if (_DeviceInfoHelper["default"].isAndroid()) {
          console.log('scrolling text input into view');
          evt.target.scrollIntoView();
        }
      },
      InputProps: {
        classes: muiClasses
      }
    }), props.disableAnswers || props.reviewMode ? null : !props.textfieldFocusedBefore && /*#__PURE__*/_react["default"].createElement("div", {
      className: _AnswersBox["default"].cursor
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"] // style={this.props.questionAnswered ? {} : {display: 'none'}}
    , {
      variant: 'contained',
      color: 'default',
      onClick: submitAnswers,
      className: "".concat(_Question2["default"].sendButton, " ").concat(props.questionAnswered ? _Question2["default"].displayNone : ''),
      disabled: props.disableAnswers ? false : _buttonDisabled2
    }, props.disableAnswers ? /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: 10
      }
    }, 'Zur nächsten Frage') : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "send"), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: 10
      }
    }, (0, _AnswerBoxStrings.getString)('SEND_ANSWER'))))));
  } else {
    var _buttonDisabled3 = props.disableAnswers ? buttonDisabled : (props.question.type === _Question.QUESTION_TYPES.MC || props.question.type === _Question.QUESTION_TYPES.SC) && selectedAnswers.length < 1 || buttonDisabled;

    var answersBoxStyle = {};
    var answersContainerStyle;
    var YNStyle = {
      marginTop: '50px'
    };
    var style = props.styles;
    var arrayAnswers = props.question.answers;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100%'
      }
    }, arrayAnswers.map(function (_answer, index) {
      var charCount = _answer.answer.replace(/<\/?[^>]+(>|$)/g, '').length;

      var normalAnswerContent = _answer.answer;
      var mathMl = null;
      var hasMathMl = false;

      if (_DeviceInfoHelper["default"].isiOS()) {
        if (_answer.answer.indexOf('<math') > -1) {
          hasMathMl = true;
        }
      } else if (_DeviceInfoHelper["default"].isAndroid() && MathJax) {
        mathMl = _StringHelper["default"].getMathMlContent(_answer.answer);

        if (mathMl && mathMl.length > 0) {
          normalAnswerContent = normalAnswerContent.replace(mathMl[0], '');
          hasMathMl = true;
        }
      }

      if (_answer.answer.indexOf('<img') > -1) {
        answersBoxStyle = {
          fontSize: (props.question.type === 'MC' || props.question.type === 'SC' || props.question.type === 'SE') && !hasMathMl ? MAX_FONT_SIZE : getFontSize(),
          lineHeight: 'inherit',
          height: '100%',
          padding: '0px'
        };
        answersContainerStyle = {
          border: '0'
        };
      } else {
        answersBoxStyle = {
          fontSize: (props.question.type === 'MC' || props.question.type === 'SC' || props.question.type === 'SE') && !hasMathMl ? MAX_FONT_SIZE : getFontSize(),
          lineHeight: 'inherit',
          paddingBottom: 0
        };
        answersContainerStyle = {
          border: "3px solid ".concat(_cssConstants["default"].colors.answerBoxColor)
        };
      }

      var answerIsChecked = selectedAnswers.indexOf(_answer) >= 0 || props.selectedAnswers && props.selectedAnswers.indexOf(_answer) >= 0 || false;
      var finalStyle = (0, _assign["default"])({}, answersContainerStyle, props.question.type === 'MC' || props.question.type === 'SC' ? style.answerStyleMCSC : style.answerStyle, (props.question.type === 'MC' || props.question.type === 'SC') && answerIsChecked ? style.selectedAnswerStyle : {}, props.question.type === 'YN' ? YNStyle : {});
      var dynamicStyles = (0, _AnswerBoxStyle.getAnswerBoxStyles)({
        quiz: quizTheme,
        currentTheme: currentTheme
      });

      var label = /*#__PURE__*/_react["default"].createElement("label", {
        onClick: props.questionAnswered ? function () {} : function (e) {
          selectAnswer(_answer);
          e.stopPropagation();
        },
        style: {
          width: '100%',
          padding: '5px'
        }
      }, !mathMl && /*#__PURE__*/_react["default"].createElement("span", {
        id: getIdForAnswerSpan(_answer.number),
        className: "answer_box_span ".concat(_AnswersBox["default"].answer_box_span, " "),
        style: (0, _assign["default"])(answersBoxStyle, style.answerTextStyle),
        onClick: _DeviceInfoHelper["default"].isAndroid() && !(index === arrayAnswers.length - 1 && buttonDisabled) ? function () {
          return selectAnswer(_answer);
        } : function () {},
        dangerouslySetInnerHTML: {
          __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(normalAnswerContent)
        }
      }), mathMl && mathMl[0] && /*#__PURE__*/_react["default"].createElement(MathJax, {
        id: getIdForAnswerSpan(_answer.number),
        style: (0, _assign["default"])(answersBoxStyle, style.answerTextStyle),
        className: "answer_box_span ".concat(_AnswersBox["default"].answer_box_span, " "),
        math: mathMl[0]
      }));

      var checkBoxIcon = _config["default"].targetSpecificCheckedIcon ? _config["default"].targetSpecificCheckedIcon : /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], null);
      var showSpecificFeedbackIcon, specificFeedback;

      var _testForAndGetSpecifi = testForAndGetSpecificFeedback(_answer);

      showSpecificFeedbackIcon = _testForAndGetSpecifi.showSpecificFeedbackIcon;
      specificFeedback = _testForAndGetSpecifi.specificFeedback;
      var answerBoxClassNames = 'answerBox';
      if (charCount === 0) answerBoxClassNames += " ".concat(_Question2["default"].answerBoxImg);else {
        if (props.isInKesi) {
          if (props.question.type === _Question.QUESTION_TYPES.MC || props.question.type === _Question.QUESTION_TYPES.SC) {
            answerBoxClassNames += " ".concat(_Question2["default"].mcAnswerBox);
          } else {
            answerBoxClassNames += " ".concat(_Question2["default"].answerBoxKesi);
          }
        } else {
          if (props.question.type === _Question.QUESTION_TYPES.MC || props.question.type === _Question.QUESTION_TYPES.SC) {
            answerBoxClassNames += " ".concat(_Question2["default"].mcAnswerBox);
          } else {
            answerBoxClassNames += " ".concat(_Question2["default"].answerBox);
          }
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: getIdForSingleAnswerContainer(_answer.number),
        className: props.question.type === _Question.QUESTION_TYPES.MC || props.question.type === _Question.QUESTION_TYPES.SC ? _Question2["default"].singleAnswerContainer_listWidth : _Question2["default"].singleAnswerContainer,
        key: "answersContainer_".concat(props.question.number, "_").concat(_answer.number),
        style: _config["default"].doNotShowSendButtonForMCSC && index === arrayAnswers.length - 1 ? {
          paddingBottom: '15px'
        } : {},
        onClick: props.disabled ? function (event) {
          if (props.question.type === _Question.QUESTION_TYPES.MC && showSpecificFeedbackIcon) {
            showSpecificFeedback(event, specificFeedback);
          } else {
            if (props.showFeedbackFn) {
              props.showFeedbackFn();
            }
          }
        } : function () {}
      }, props.disableAnswers ? null : /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        id: getIdForAnswerLabel(_answer.number),
        key: getIdForAnswerLabel(_answer.number),
        row: true,
        style: finalStyle,
        className: answerBoxClassNames
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        label: label,
        classes: {
          root: _Question2["default"].formControlLabelRoot
        },
        style: dynamicStyles.answerBoxStyle,
        control: props.question.type === _Question.QUESTION_TYPES.MC ? /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          onChange: props.questionAnswered ? function () {
            console.log('selectAnswer123');
          } : function () {
            return selectAnswer(_answer);
          },
          checkedIcon: checkBoxIcon,
          disabled: props.disabled || props.questionAnswered,
          className: _AnswersBox["default"].answerInput,
          style: dynamicStyles.answerBoxStyle,
          checked: answerIsChecked
        }) : /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
          onChange: props.questionAnswered ? function () {
            console.log('selectAnswer123');
          } : function () {
            return selectAnswer(_answer);
          },
          disabled: props.disabled || props.questionAnswered,
          className: _AnswersBox["default"].answerInput,
          style: props.question.type !== _Question.QUESTION_TYPES.SC ? {
            display: 'none'
          } : dynamicStyles.answerBoxStyle,
          checked: answerIsChecked
        })
      }), showSpecificFeedbackIcon ? /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick(event) {
          return showSpecificFeedback(event, specificFeedback);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Feedback["default"], {
        className: _Question2["default"].feedBackIcon
      })) : null));
    }), props.question.type !== _Question.QUESTION_TYPES.QD && props.question.type !== _Question.QUESTION_TYPES.YN ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _Question2["default"].sendButtonContainer,
      style: _config["default"].doNotShowSendButtonForMCSC ? {
        height: '20px'
      } : {
        marginTop: 20,
        marginBottom: 20,
        height: 'auto'
      }
    }, _config["default"].doNotShowSendButtonForMCSC ? null : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: 'submitButton',
      onClick: submitAnswers,
      className: "".concat(_Question2["default"].sendButton, " ").concat(props.questionAnswered ? _Question2["default"].displayNone : ''),
      disabled: _buttonDisabled3
    }, props.disableAnswers ? /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: 10
      }
    }, 'Zur nächsten Frage') : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "send"), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: 10
      }
    }, (0, _AnswerBoxStrings.getString)('SEND_ANSWER')))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _Question2["default"].scrollIndicatorAnswersBox,
      style: !props.showScrollIndicator ? {
        display: 'none'
      } : {},
      onTouchStart: setIntervalHandleAnswerBox,
      onTouchEnd: clearIntervalHandleAnswerBox,
      onMouseDown: setIntervalHandleAnswerBox,
      onMouseUp: clearIntervalHandleAnswerBox
    }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], {
      className: _Question2["default"].arrowFirstAnswersBox,
      style: {
        fontSize: 'xx-large'
      }
    }), /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], {
      className: _Question2["default"].arrowSecondAnswersBox,
      style: {
        fontSize: 'xx-large'
      }
    }))) : null);
  }
}